import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7b24fe35 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _49ff2c7d = () => interopDefault(import('..\\pages\\reimbursement\\index.vue' /* webpackChunkName: "pages_reimbursement_index" */))
const _67940594 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _575b44e7 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _42bd1dd8 = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _f190e100 = () => interopDefault(import('..\\pages\\enroll\\insurance-information.vue' /* webpackChunkName: "pages_enroll_insurance-information" */))
const _6509fd6b = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _0e36a5cd = () => interopDefault(import('..\\pages\\enroll\\prescriber-information.vue' /* webpackChunkName: "pages_enroll_prescriber-information" */))
const _1d97320a = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _69f40dd4 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _69d7ded2 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _699f80ce = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _698351cc = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _00279752 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _375edfff = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _7b24fe35,
    name: "error"
  }, {
    path: "/reimbursement",
    component: _49ff2c7d,
    name: "reimbursement"
  }, {
    path: "/rejection",
    component: _67940594,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _575b44e7,
    name: "unlock"
  }, {
    path: "/enroll/eligibility",
    component: _42bd1dd8,
    name: "enroll-eligibility"
  }, {
    path: "/enroll/insurance-information",
    component: _f190e100,
    name: "enroll-insurance-information"
  }, {
    path: "/enroll/patient-information",
    component: _6509fd6b,
    name: "enroll-patient-information"
  }, {
    path: "/enroll/prescriber-information",
    component: _0e36a5cd,
    name: "enroll-prescriber-information"
  }, {
    path: "/enroll/success",
    component: _1d97320a,
    name: "enroll-success"
  }, {
    path: "/errors/400",
    component: _69f40dd4,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _69d7ded2,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _699f80ce,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _698351cc,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _00279752,
    name: "errors-500"
  }, {
    path: "/",
    component: _375edfff,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
